import { render, staticRenderFns } from "./AgeRangePyramidChart.vue?vue&type=template&id=6b95b9ad&scoped=true"
import script from "./AgeRangePyramidChart.vue?vue&type=script&lang=js"
export * from "./AgeRangePyramidChart.vue?vue&type=script&lang=js"
import style0 from "./AgeRangePyramidChart.vue?vue&type=style&index=0&id=6b95b9ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95b9ad",
  null
  
)

export default component.exports